// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__HcgG-","tooltipWpapper":"Tooltip_tooltipWpapper__WwUtT"};